<template>
  <hr class="mx-3 my-2 border-gray-200" />
  <div class="px-2 pb-2">
    <div class="px-2 mb-2 flex items-center gap-2">
      <component :is="icon" v-bind="iconProps" />
      <div class="w-full">
        <Select :model-value="selectedId" @update:model-value="onUpdateSelected">
          <SelectTrigger class="p-0 px-2 border-none shadow-none">
            <SelectValue class="text-black text-lg font-normal">
              {{ displayName }}
            </SelectValue>
          </SelectTrigger>
          <SelectContent>
            <SelectItem
              v-for="option in options"
              :key="option.id"
              :value="option.id.toString()"
            >
              {{ option.name }}
            </SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>

    <ul class="flex flex-col gap-0.5">
      <li v-for="link in links" :key="link.name">
        <router-link
          :to="link.to"
          class="flex items-center gap-3 px-2 py-2 text-sm text-gray-700 rounded-lg hover:bg-gray-100 transition-all duration-300"
          :class="{ 'bg-cosmicPurple/10 font-medium text-cosmicPurple': isLinkActive(link) }"
          @click="$emit('linkClick')"
        >
          <component
            :is="link.icon"
            class="w-5 h-5 shrink-0"
            :class="isLinkActive(link) ? 'text-cosmicPurple' : 'text-gray-400'"
          />
          <span>{{ link.name }}</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { computed, type Component } from 'vue'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import type { ContextNavLink } from '@/const/sidebarLinks'

interface Option {
  id: string | number
  name: string
}

const props = defineProps<{
  icon: Component
  iconSize?: number
  iconClass?: string
  selectedId: string | null
  options: Option[]
  displayName: string
  links: ContextNavLink[]
  isLinkActive: (link: ContextNavLink) => boolean
}>()

const emit = defineEmits<{
  'update:selectedId': [value: string | null]
  linkClick: []
}>()

const iconProps = computed(() => {
  if (props.iconSize !== undefined) {
    return { size: props.iconSize }
  }
  if (props.iconClass) {
    return { class: props.iconClass }
  }
  return {}
})

function onUpdateSelected(value: unknown) {
  emit('update:selectedId', value == null ? null : String(value))
}
</script>
